import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';
import { format } from 'rut.js';

@Directive({
  selector: '[rutFormatGuion]',
  standalone: true,
})
export class RutFormatGuionDirective {
  private readonly el = inject(ElementRef<HTMLInputElement>);
  private readonly control = inject(NgControl, { optional: true });

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const value = target.value;

    const formatted = format(value);

    this.el.nativeElement.value = formatted;

    this.control?.control?.setValue(formatted, { emitEvent: false });
  }

  @HostListener('blur')
  onBlur(): void {
    const value = this.el.nativeElement.value;
    if (value) {
      const mockEvent = { target: this.el.nativeElement } as unknown as Event;
      this.onInputChange(mockEvent);
    }
  }
}
